import {lazy} from '@aboutyou/lazy-imports';
import {usePathname} from '@aboutyou/router';
import React, {useEffect, useRef} from 'react';
import {useEntryUrlCrmCouponTokenParam} from '../../../features/Coupons/useCrmCouponTokenParam';
import {useIsOmEntry, useSearchWithoutOmEntryParam} from '../utils/omEntry';

const StreamGenderSwitchFetcher = lazy(() =>
  import('./StreamGenderSwitch.eager').then(mod => ({
    default: mod.StreamGenderSwitch,
  })),
);

export const StreamGenderSwitch: React.FC = () => {
  const {isUnisex} = useRef(useIsOmEntry()).current;
  const crmCouponToken = useEntryUrlCrmCouponTokenParam();

  const pathname = usePathname();
  const updatedSearch = useSearchWithoutOmEntryParam();
  const queryString = updatedSearch ? `?${updatedSearch}` : updatedSearch;

  /**
   * We remove the omUnisex query params from the url without triggering a re-render using native history.replaceState
   * Do not use react-router history.replace as that will cause a re-render and re-fetching of complete category page
   */
  // eslint-disable-next-line local-rules/prefer-use-history
  useEffect(() => {
    if (isUnisex) {
      history.replaceState(null, '', `${pathname}${queryString}`);
    }
  }, [isUnisex, pathname, queryString]);

  if (!isUnisex && !crmCouponToken) {
    return null;
  }

  return <StreamGenderSwitchFetcher />;
};
